import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { memo } from 'react'

type SortableItemProps = {
  id: number | string
  children: React.ReactNode
}

const KanbanSortableItem = ({ id, children }: SortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)'
    }
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging
      ? undefined
      : transition || 'transform 150ms cubic-bezier(0.25, 0.1, 0.25, 1)',
    opacity: isDragging ? 0.4 : 1,
    cursor: isDragging ? 'grabbing' : 'grab',
    willChange: isDragging ? 'transform' : 'auto'
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  )
}

export const KanbanSortable = memo(KanbanSortableItem)
